<template>
  <div class="personal">
    <div class="personal_top"></div>
    <p class="personal_title">个人中心</p>
    <div class="personal_head">
      <div class="upimg">
        <form class="upload" enctype="multipart/form-data">
          <img class="uploadImg" src="../../assets/images/personal/upload.png">
          <input type="file" class="uploadFile" name="uploadFile" multiple="multiple">
        </form>
        <div class="showImg"><img :src="head_url"></div>
      </div>
    </div>
    <div class="personal_main">
      <div class="personal_left">
        <el-row class="nav">
          <el-col :span="24">
            <el-menu default-active="2" style="text-align: left" class="el-menu-vertical-demo" @close="handleClose">
              <el-menu-item index="1">
                  <span slot="title">
                    <router-link to="/personal/index" active-class="selected">個人情報</router-link>
                  </span>
              </el-menu-item>
              <el-menu-item index="2">
                  <span slot="title">
                    <router-link to="/personal/order" active-class="selected">購入履歴</router-link>
                  </span>
              </el-menu-item>
              <el-menu-item index="3">
                  <span slot="title">
                <router-link to="/personal/collect" active-class="selected">お気に入り</router-link>
              </span>
              </el-menu-item>
              <el-menu-item index="4">
                  <span slot="title">
                <router-link to="/personal/changePwd" active-class="selected">パスワード再設定</router-link>
              </span>
              </el-menu-item>
              <el-menu-item index="5">
                  <span slot="title">
                <router-link to="/personal/address" active-class="selected">ショッピングカート</router-link>
              </span>
              </el-menu-item>
            </el-menu>
          </el-col>
        </el-row>
      </div>
      <div class="personal_right">
        <router-view></router-view>
      </div>
    </div>
    <div class="personalFooter"></div>
    <ul class="Mnav">
      <router-link to="/personal/index">
        <li class="firts"><span>個人情報</span><img src="../../assets/images/personal/right.png"></li>
      </router-link>
      <router-link to="/personal/order">
        <li><span>購入履歴</span><img src="../../assets/images/personal/right.png"></li>
      </router-link>
      <router-link to="/personal/collect">
        <li><span>お気に入り</span><img src="../../assets/images/personal/right.png"></li>
      </router-link>
      <router-link to="/personal/changePwd">
        <li><span>パスワード変更</span><img src="../../assets/images/personal/right.png"></li>
      </router-link>
      <router-link to="/personal/address">
        <li><span>受け取り先</span><img src="../../assets/images/personal/right.png"></li>
      </router-link>
      <li @click="openShade"><span>登録をやめる</span></li>
    </ul><!--M端个人中心-->
    <div id="shade" class="shade">
      <p>プロンプト</p>
      <p>ログアウトを確定しますか?</p>
      <p>
        <button @click="closeShade">きゃんせる</button>
        <button @click="ExitLogin">応答する</button>
      </p>
    </div>

  </div>
</template>

<script>
  import {getUserInfo, uploadUserIcon} from './../../api/interface/users';
  import {bus} from '../../main'
  export default{
    name: "",
    data(){
      return {
        head_url: localStorage.getItem('headImg') || "",
        centerDialogVisible: false,
      }
    },
    beforeMount(){
      bus.$on("headImg", (Img) => {
        this.head_url = Img;
      });
      this.getUserInfo();
    },
    mounted(){
      $(".uploadFile").on("change", (e) => {
        let file = e.target.files[0];
        console.log(file);
        this.preview(file);
        this.upload();
      })
    },
    methods: {
      //前端预览头像
      preview(file) {
        let img = new Image();
        img.src = URL.createObjectURL(file);
        let url = img.src;
        let $img = $(img);
        $(img).css({"width": "100%", "height": "100%",});
        img.onload = function () {
          URL.revokeObjectURL(url);
          $('.showImg').empty().append($img);
          // console.log($('.userPic').append($img).html());
        }
      },
//      获取用户信息
      getUserInfo(){
        getUserInfo().then(result => {
          if (result.code === 1) {
            this.userInfo = result.resData;
            this.head_url = this.userInfo.head_url;
            localStorage.setItem('headImg', this.userInfo.head_url);
            bus.$emit("headImg", this.head_url)
          }
        }).catch(err => {
          if (err.code === 2) {
            console.log('token缺少相关用户信息')
          } else if (err.code === 5) {
            console.log(err.message)  //用户不存在
          }
        })
      },
      //上传头像
      upload() {
        let formdata = new FormData($('.upload')[0]);
        console.log(formdata);
        formdata.append('user_head', this.head_url);
        let token = localStorage.getItem('token') || 0;
        token = "Bearer " + token;
        $.ajax({
          type: 'post',
          url: 'http://116.255.243.162:3002/co/account/uploadUserIcon',
          data: formdata,
          async: false,
          cache: false,
          contentType: false,
          processData: false,
          beforeSend: function (request) {
            request.setRequestHeader("Authorization", token);
          },
          success: function (result) {
            console.log("上传信息：");
            console.log(result);
            if (result.code == 1) {
              console.log("成功");
//              history.go(0);
            }
            else {
              console.log("失败");
            }
          },
          error: function (err) {
            alert('error');
          }
        })
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
      },

      openShade() {
        $("#shade").fadeTo(200, 1);
      },
      closeShade(){
        $("#shade").fadeOut(200, 0);
      },
      ExitLogin(){
        $("#shade").fadeOut(200, 0);
        this.islogin = "";
        localStorage.clear('token');
        localStorage.clear('headImg');
        this.$router.push({path: "/login"})
      },
    },
    components: {}
  }
</script>
<style lang="scss">
  @import "../../../static/pubilc";

  @media screen and(min-width: $min-screen) and(max-width: $P749screen) {
    .personal {
      .personal_top {
        display: none;
      }
      .personal_title {
        height: 50px;
        line-height: 50px;
        background-color: #eba898;
        text-align: center;
        letter-spacing: $letter;
        color: white;
        font-size: 18px;
      }
      .personal_head {
        height: 80px;
        width: 100%;
        background-color: white;
        margin: 0 auto;
        padding: 35px 0;
        .upimg {
          margin: 0 auto;
          position: relative;
          height: 80px;
          width: 80px;
          border-radius: 50%;
          box-shadow: 0 0 1px 2px #f9f9f9;
          .upload {
            height: 80px;
            width: 80px;
            .uploadImg {
              margin: 20px;
              height: 40px;
              width: 40px;
            }
            .uploadFile {
              position: absolute;
              left: 0;
              top: 0;
              width: 80px;
              height: 80px;
              border-radius: 50%;
              opacity: 0;
              z-index: 2;
            }
          }
          .showImg {
            position: absolute;
            width: 80px;
            height: 80px;
            overflow: hidden;
            border-radius: 50%;
            margin-top: -80px;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
      .personal_main {
        display: none;
      }
      .personalFooter {
        display: none;
      }
      .Mnav {
        width: 100%;
        padding-bottom: 50px;
        background-color: white;
        li {
          font-size: 14/$default-w+rem;
          height: 45px;
          line-height: 45px;
          border-bottom: 1px solid #a1a1a1;
          display: flex;
          justify-content: space-between;
          align-items: center;
          span:nth-child(1) {
            color: black;
            margin-left: 5%;
          }
          img {
            margin-right: 5%;
            height: 15px;
            width: 15px;
          }
        }
        .firts {
          border-top: 1px solid #a1a1a1;
        }
      }
      .shade {
        position: absolute;
        display: none;
        height: 4rem;
        width: 7rem;
        background-color: white;
        z-index: 999;
        top: 5.89rem;
        left: 0;
        margin-left: 1.5rem;
        border-radius: 5px;
        box-shadow: 2px 1px 20px #333333;
        letter-spacing: $letter;
        font-size: 14/$default-w+rem;
        p {
          width: 100%;
          text-align: center;
        }
        p:nth-child(1) {
          height: 1rem;
          font-size: 16/$default-w+rem;
          background-color: $TitColor;
          line-height: 1rem;
        }
        p:nth-child(2) {
          height: 1.5rem;
          line-height: 1.5rem;
          /*background-color: #dd6161;*/
        }
        p:nth-child(3) {
          display: flex;
          justify-content: space-around;
          button {
            outline: none;
            border: none;
            height: 1rem;
            width: 3rem;
            margin-top: 0.25rem;
            border-radius: 10px;
          }
          button:nth-child(1) {
            background-color: #dddddd;
          }
          button:nth-child(2) {
            background-color: $TitColor;
            color: white;
          }
        }
      }
    }
  }

  @media screen and(min-width: $P750screen) {
    .personal {
      width: 100%;
      margin: 0 auto;
      background-color: white;
      .personal_title {
        display: none;
      }
      .personal_top {
        height: 95px;
        width: 100%;
        font-size: 30px;
        line-height: 95px;
        text-align: center;
        color: $navcolor;
        background-color: $bgcolor;
      }
      .personal_head {
        height: 70px;
        background-color: white;
        margin: 0 auto;
        width: 100%;
        max-width: $width;
        .upimg {
          position: relative;
          display: inline-block;
          height: 140px;
          width: 140px;
          border-radius: 50%;
          margin-top: -70px;
          .uploadImg {
            margin: 46px;
            height: 48px;
            width: 48px;
          }
          .uploadFile {
            position: absolute;
            left: 0;
            top: 0;
            width: 140px;
            height: 140px;
            border-radius: 50%;
            opacity: 0;
            z-index: 2;
          }
          .showImg {
            position: absolute;
            width: 140px;
            height: 140px;
            border-radius: 50%;
            overflow: hidden;
            margin-top: -144px;
            img {
              width: 100%;
              height: 100%;
            }
          }

        }
      }
      .personal_main {
        width: 100%;
        max-width: $width;
        margin: 0 auto;
        margin-top: 20px;
        padding: 20px 0;
        display: flex;
        justify-content: space-around;
        .personal_left {
          height: 100%;
          width: 160px;
          .el-menu {
            border-right: none;
            /*text-align: center;*/
            /*padding: 0;*/
            /*<!--padding-left: -120px;-->*/
            .el-menu-item {
              padding: 0;
              span {
                display: block;
                width: 100%;
                a {
                  display: block;
                  width: 100%;
                  text-decoration: none;
                  color: black;
                  box-sizing: border-box;
                }
                .selected {
                  color: $navcolor;
                }
              }
            }
          }
        }
        .personal_right {
          height: 100%;
          width: 100%;
          min-width: 610px;
          position: relative;
        }
      }
      .personalFooter {
        height: 70px;
        width: 100%;
        background-color: $bgcolor;
      }
      .Mnav {
        display: none;
      }
      .shade {
        display: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/personal/personal.vue